import React from 'react'
import { MdAddCircle } from "react-icons/md";

const AddCardLink = ({onClick, t, laneId}: any) => <button
  onClick={onClick}
  className='w-full flex justify-center items-center text-gray-500 hover:text-amber-600'>
    <MdAddCircle className='mr-2'/>
    Nouvelle activité
  </button>

export default AddCardLink
